<!-- Normal slabs UI -->
<div *ngIf="!isReward && !payment_config?.is_sip" class="tokens-div" [ngClass]="theme" [ngClass]="{'compact-ui': vars?.fundraiser?.is_multi_patient_campaign && vars.pageName!=='mini_story'}">
  <button *ngFor="let slab of slabs" class="amount-token" [ngClass]="{'selected': slab.isSelected}" type="button" (click)="setAmount(slab);vars.resetSelectedKCart.next(true)" mat-raised-button>
    <div *ngIf="contributeDetails.default_amount === slab.amount && recommendTag" class="recommended-tag">{{tagLabel || 'RECOMMENDED'}}</div>
    <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>
    &nbsp;{{slab.amount}}
    <span *ngIf="type=='sip_cause'" class="month-label memorial" [ngClass]="{'month-label-s': slab.isSelected}">/Month</span>
  </button>
</div>

<div *ngIf="!isReward && payment_config?.is_sip" class="tokens-div">
  <button *ngFor="let slab of slabs" class="amount-token" [ngClass]="{'selected': slab.isSelected}" type="button" (click)="setAmount(slab)" mat-raised-button>
    <div>
      <div><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>{{slab.amount}}</div>
      <div class="month-label" [ngClass]="{'active': slab.isSelected}">per month</div>
    </div>
  </button>
</div>


<form [formGroup]="amountForm" [ngClass]="{'compact-ui': vars?.fundraiser?.is_multi_patient_campaign && vars.pageName!=='mini_story'}">
  <div class="text-center">
    <!-- Normail Other input -->
    <button #otherAmountBtnRef type="button" class="other-amount" (click)="otherAmountAnimate()" [ngClass]="{'error-border':amount.touched && amount?.invalid && (!payment_config?.enable_min_cart_lead || payment_config?.cart_response)}" mat-raised-button disableRipple>
      {{language === 'en' || otherAmountSelected ? otherAmountLabel : ('Stories.donations.otheramount' | translatePipe | async)}}
      <div #otherAmountRef class="amount-input" (click)="$event.stopPropagation();">
        <app-currency-dropdown class="amout-select" [selectedCurrency]="currency"
                              [currencies]="contributeDetails?.supported_currency" (userSelectionCurrency)="setCurrency($event)">
        </app-currency-dropdown>
        <input type="number" #amountRef class="other-input" formControlName="amount" [min]="contributeDetails?.min_donation || 0" (click)="otherAmountAnimate()" (wheel)="$event.preventDefault()" (blur)="otherAmountBlur($event?.target?.value)">
      </div>
    </button>
    <div *ngIf="amount.touched && amount.invalid && (!payment_config?.enable_min_cart_lead || payment_config?.cart_response)" class="other-error">
      <div *ngIf="amount.hasError('required')">{{'Stories.bankTransfer.requiredField' | translatePipe | async}}</div>
      <div *ngIf="amount.hasError('pattern')">Invalid Amount</div>
      <div *ngIf="amount.hasError('min')">
        {{'Stories.bankTransfer.valueGreaterValidation' | translatePipe | async}}
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{contributeDetails?.min_donation}}.
      </div>
      <div *ngIf="amount.hasError('max')">Please enter a value less than or equal to <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{max_donation}}.</div>
    </div>
    <div *ngIf="!amount?.invalid && params?.mini_story" class="tax-nudge">Bigger the contribution, bigger your tax savings</div>
  </div>
</form>
